import $ from 'jquery';

export default $subscriptionsByAgeInterest => {
    $subscriptionsByAgeInterest.each((i, el) => {
        const $collection = $(el);
        const $subs = $collection.find('.subscriptions-by-age-interest-sub');
        const $filters = $collection.find('.sub-list__filters__radio');

        $filters.change(function() {
            const ageRange = $collection
                .find('.sub-list__filters__radio:checked')
                .first()
                .val();
            let filtered = true;

            $subs.each(function() {
                const ageRanges = $(this)
                    .attr('data-age-ranges')
                    .split(',');

                if (ageRange === 'all') {
                    filtered = false;
                    $(this).show();
                } else if (ageRanges.includes(ageRange)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });

            if (filtered) {
                if (!$collection.hasClass('--filtered')) {
                    $collection.addClass('--filtered');
                }
            } else if (!filtered) {
                if ($collection.hasClass('--filtered')) {
                    $collection.removeClass('--filtered');
                }
            }
        });
    });
};
